import React from "react";
import RangeSlider from "react-bootstrap-range-slider";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";

export default function SliderComponent({
  label,
  setMaterialOpacity,
  value: opacityValue,
  onSliderChange,
  showInput = false,
  onAfterChange = null,
  min = 0,
  max = 1,
  step = 0.1,
}) {
  const handleBlur = () => {
    if (opacityValue < 0 || Number.isNaN(opacityValue)) {
      setMaterialOpacity(0);
    } else if (opacityValue > 1) {
      setMaterialOpacity(100);
    }
  };

  return (
    <div className="sliderContainer">
      {label && <div className="sliderLabel">{label}</div>}
      <div className="componentContainer">
        <RangeSlider
          onChange={(event) => onSliderChange(parseFloat(event.target.value))}
          onAfterChange={(event) => {
            if (onAfterChange) {
              onAfterChange(parseFloat(event.target.value));
            }
          }}
          step={step}
          min={min}
          max={max}
          value={opacityValue}
        />
        {showInput && (
          <InputGroup>
            <FormControl
              type="number"
              placeholder="0"
              aria-label="Username"
              aria-labelledby="input-slider"
              onChange={(event) => {
                const updatedValue =
                  event.target.value === "" ? 0 : Number(event.target.value);
                setMaterialOpacity(updatedValue);
              }}
              onBlur={handleBlur}
              value={opacityValue}
              step={step}
              min={min}
              max={max}
            />
          </InputGroup>
        )}
      </div>
    </div>
  );
}
